export function DrawDeliveryModel () {
    this.campaignImgUrl = '';
    this.campaignName = '';
    this.campaignExpiredTimestamp = '';
    this.privilegeMessage = '';
    this.privilegeMessageFormat = '';
    this.type = '';

    this.setModelFromDataModel = dict => {
        this.campaignImgUrl = dict.fullImageUrl || '';
        this.campaignName = dict.name || '';
        this.campaignExpiredTimestamp = dict.expireDate || '';
        this.privilegeMessage = dict.privilegeMessage || '';
        this.privilegeMessageFormat = dict.privilegeMessageFormat || '';
        this.type = dict.type || '';
    };
}
